import src from "IMAGE";
export default { src, width: 540, height: 137, blurWidth: 0, blurHeight: 0};
